import { render, staticRenderFns } from "./tw_header.vue?vue&type=template&id=4046b2a8&scoped=true&"
import script from "./tw_header.vue?vue&type=script&lang=js&"
export * from "./tw_header.vue?vue&type=script&lang=js&"
import style0 from "./tw_header.vue?vue&type=style&index=0&id=4046b2a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046b2a8",
  null
  
)

export default component.exports